import { render, staticRenderFns } from "./DealRow.vue?vue&type=template&id=70cfc13a&scoped=true&lang=pug&"
import script from "./DealRow.vue?vue&type=script&lang=js&"
export * from "./DealRow.vue?vue&type=script&lang=js&"
import style0 from "./DealRow.vue?vue&type=style&index=0&id=70cfc13a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70cfc13a",
  null
  
)

export default component.exports